import enviro from 'enviro';
import { combineReducers } from 'redux';
import thunk from 'redux-thunk';
import { configureStore } from '@reduxjs/toolkit';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'Redu... Remove this comment to see the full error message
import NotificationMiddleware from 'ReduxMessenger/middleware/NotificationMiddleware';
import makeRavenErrorReportingMiddleware from '../middleware/RavenErrorReportingMiddleware';
import ravenMiddlewareConfig from './ravenMiddlewareConfig';
import { staticReducers, globalStateReducers } from '../reducers';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'Redu... Remove this comment to see the full error message
import reduceReducers from 'editor-iframe-lib/redux/utils/reduceReducers';
import * as ActionTypes from '../actions/ActionTypes';
import { matchPath, generatePath } from 'react-router-dom';
import { ROOT_KB_PATH } from '../routing/constants/RouteConstants';
const initialReducer = combineReducers(Object.assign({}, staticReducers));
export function createReducer(asyncInjectedReducers = {}) {
  const combinedReducer = combineReducers(Object.assign({}, staticReducers, asyncInjectedReducers));
  return reduceReducers(combinedReducer, ...globalStateReducers);
}
const routerMiddleware = history => () => next => action => {
  if (action.type === ActionTypes.HISTORY_METHOD_CALLED) {
    const {
      payload: {
        method,
        location
      }
    } = action;
    const match = matchPath(history.location.pathname, {
      path: ROOT_KB_PATH
    });
    const nextLocation = typeof location === 'string' ? location : location.pathname;
    if (match) {
      const newLocation = generatePath(nextLocation, match.params);
      history[method](newLocation);
    } else {
      history[method](location);
    }
  }
  return next(action);
};
const storeForTypes = configureStore({
  reducer: createReducer(),
  middleware: [thunk, NotificationMiddleware, makeRavenErrorReportingMiddleware(ravenMiddlewareConfig)]
});
export default function createStore(initialState, {
  history
}) {
  const store = Object.assign({}, configureStore({
    reducer: createReducer(),
    middleware: [thunk, NotificationMiddleware, routerMiddleware(history), makeRavenErrorReportingMiddleware(ravenMiddlewareConfig)],
    preloadedState: initialState,
    devTools: window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ && enviro.debug('knowledge-content-ui') && {
      name: 'knowledge-content-ui'
    }
  }), {
    asyncInjectedReducers: {},
    injectReducer(key, reducer) {
      store.asyncInjectedReducers[key] = reducer;
      const newRootReducer = createReducer(store.asyncInjectedReducers);
      store.replaceReducer(newRootReducer);
    }
  });
  return store;
}